'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  animateExit: _propTypes2.default.bool,
  vertical: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['default', 'warning', 'error', 'success', 'info'])
};
var defaultProps = {
  animateExit: false,
  vertical: false,
  colorScheme: 'default'
};

var style = function style(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.alertsArea.item.colorScheme,
      borderRadius = _theme$reactackle$com.borderRadius,
      minWidth = _theme$reactackle$com.minWidth,
      maxWidth = _theme$reactackle$com.maxWidth,
      fontSize = _theme$reactackle$com.fontSize;
  return (0, _styledComponents.css)(['border-radius:', ';min-width:', ';max-width:', ';font-size:', ';'], (0, _reactackleCore.getValueString)(borderRadius), (0, _reactackleCore.getValueString)(minWidth), (0, _reactackleCore.getValueString)(maxWidth), (0, _reactackleCore.getValueString)(fontSize));
};

var layoutDirection = function layoutDirection(_ref2) {
  var vertical = _ref2.vertical;
  return vertical ? '\n    flex-direction: column;\n    align-items: stretch;\n  ' : '\n    layout-direction: row;\n    align-items: center;\n  ';
};

var animation = function animation(_ref3) {
  var themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com2 = theme.reactackle.components.alertsArea.item.animation.in,
      name = _theme$reactackle$com2.name,
      speed = _theme$reactackle$com2.speed,
      timingFunction = _theme$reactackle$com2.timingFunction;
  return 'animation: ' + name + ' ' + speed + ' ' + timingFunction + ';';
};

var animationExit = function animationExit(_ref4) {
  var themeFromProvider = _ref4.theme,
      animateExit = _ref4.animateExit;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com3 = theme.reactackle.components.alertsArea.item.animation.out,
      name = _theme$reactackle$com3.name,
      speed = _theme$reactackle$com3.speed,
      timingFunction = _theme$reactackle$com3.timingFunction;
  return animateExit && 'animation: ' + name + ' ' + speed + ' ' + timingFunction + ';';
};

var colorScheme = function colorScheme(_ref5) {
  var colorScheme = _ref5.colorScheme,
      themeFromProvider = _ref5.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com4 = theme.reactackle.components.alertsArea.item.colorScheme[colorScheme],
      textColor = _theme$reactackle$com4.textColor,
      backgroundColor = _theme$reactackle$com4.backgroundColor;
  return '\n    color: ' + textColor + ';\n    background-color: ' + backgroundColor + ';\n  ';
};

var AlertStyled = exports.AlertStyled = _styledComponents2.default.div.withConfig({
  displayName: 'AlertStyled'
})(['width:100%;display:flex;', ' ', ' ', ' ', ' ', ''], style, layoutDirection, animation, animationExit, colorScheme);

AlertStyled.propTypes = propTypes;
AlertStyled.defaultProps = defaultProps;